import { useEffect, useState } from "react";
import { ArrowRight, Briefcase, Users, ShieldCheck, BadgeCheck, IndianRupee } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";

const KEY = "bg_choice_seen";

const Choice = ({ testId, img, Icon, title, hindi, sub, accent, onClick }) => (
  <button type="button" data-testid={testId} onClick={onClick}
    className="group relative flex flex-row overflow-hidden rounded-2xl bg-white outline-none focus-visible:ring-2 focus-visible:ring-orange-500 sm:flex-col text-left shadow-md ring-1 ring-slate-200 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl">
    <div className="relative w-28 shrink-0 overflow-hidden sm:h-40 sm:w-full">
      <img src={img} alt="" className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
    </div>
    <span className={`absolute left-[5.5rem] top-3 flex h-9 w-9 items-center justify-center rounded-xl text-white shadow-lg sm:left-4 sm:top-[8.6rem] sm:h-11 sm:w-11 ${accent}`}><Icon className="h-5 w-5" /></span>
    <div className="flex flex-1 flex-col px-4 py-3 pl-8 sm:pb-4 sm:pl-4 sm:pt-8">
      <p className="font-heading text-xl font-bold text-[#0B1120]">{title}</p>
      <p className="notranslate text-sm font-semibold text-orange-600">{hindi}</p>
      <p className="mt-1 flex-1 text-sm leading-snug text-slate-500 sm:mt-2">{sub}</p>
      <span className="mt-3 inline-flex items-center gap-1 text-sm font-bold text-[#0B1120] transition-colors group-hover:text-orange-600">
        Continue <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
      </span>
    </div>
  </button>
);

const TRUST = [[ShieldCheck, "KYC verified"], [BadgeCheck, "Free registration"], [IndianRupee, "No fee from employees"]];

export const ChoicePopup = ({ onPick }) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (sessionStorage.getItem(KEY) || new URLSearchParams(window.location.search).get("join")) return undefined;
    const t = setTimeout(() => setOpen(true), 600);
    return () => clearTimeout(t);
  }, []);
  const close = () => { sessionStorage.setItem(KEY, "1"); setOpen(false); };
  const pick = (t) => { close(); setTimeout(() => onPick(t), 250); };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) close(); }}>
      <DialogContent data-testid="choice-popup" className="max-h-[92vh] w-[calc(100vw-1.5rem)] max-w-3xl overflow-y-auto rounded-3xl border-0 bg-[#F3F5F8] p-5 text-slate-800 sm:p-7">
        <div className="flex items-center gap-3">
          <img src="/img/bgr-logo.png" alt="Balangir Group" className="h-12 w-auto" />
          <div>
            <DialogTitle className="font-heading text-2xl font-bold text-[#0B1120]">Namaste! What are you looking for?</DialogTitle>
            <DialogDescription className="notranslate text-sm text-slate-500">नमस्ते! आप क्या ढूंढ रहे हैं? एक विकल्प चुनें।</DialogDescription>
          </div>
        </div>
        <div className="mt-3 grid gap-4 sm:grid-cols-2">
          <Choice testId="choice-job" img="/images/jobseeker.jpg" Icon={Briefcase} accent="bg-[#1E3A8A]" title="Find a Job" hindi="नौकरी ढूंढें"
            sub="Register free and get matched to verified jobs near you." onClick={() => pick("worker")} />
          <Choice testId="choice-hire" img="/images/hirer.jpg" Icon={Users} accent="bg-orange-500" title="Hire Staff" hindi="स्टाफ रखें"
            sub="Verified guards, staff and labour for your company." onClick={() => pick("employer")} />
        </div>
        <div className="mt-2 flex flex-wrap justify-center gap-x-6 gap-y-1 text-xs font-medium text-slate-500" data-testid="choice-trust">
          {TRUST.map(([I, t]) => <span key={t} className="flex items-center gap-1.5"><I className="h-4 w-4 text-emerald-600" />{t}</span>)}
        </div>
      </DialogContent>
    </Dialog>
  );
};
